import { Link } from 'react-router-dom'
import { CheckCircle2 } from 'lucide-react'

interface ProgramCardProps {
  icon: string
  title: string
  ageRange: string
  description: string
  features: string[]
  available?: boolean
  comingSoon?: boolean
}

export default function ProgramCard({
  icon,
  title,
  ageRange,
  description,
  features,
  available = true,
}: ProgramCardProps) {
  return (
    <div
      className={`relative card flex flex-col h-full transition-all duration-300 ${
        available
          ? 'hover:shadow-lift hover:-translate-y-1'
          : 'opacity-60 grayscale'
      }`}
    >
      {!available && (
        <div className="absolute top-4 right-4 bg-slate-100 text-slate-500 text-xs font-bold px-2.5 py-1 rounded-full">
          {/* TODO: Remove this badge once program is confirmed active */}
          Coming Soon
        </div>
      )}

      {/* Icon + badge */}
      <div className="flex items-start gap-4 mb-4">
        <div className="text-3xl leading-none" aria-hidden="true">{icon}</div>
        <div>
          <h3 className="text-brand-navy font-display font-bold text-xl leading-tight">{title}</h3>
          <span className="inline-block mt-1 text-xs font-round font-bold text-brand-blue bg-brand-sky/15 px-2.5 py-0.5 rounded-full">
            Ages: {ageRange}
          </span>
        </div>
      </div>

      {/* Description */}
      <p className="text-slate-500 text-sm leading-relaxed mb-5 flex-1">{description}</p>

      {/* Feature list */}
      <ul className="space-y-2 mb-6" role="list">
        {features.map((feat) => (
          <li key={feat} className="flex items-start gap-2 text-sm text-slate-600">
            <CheckCircle2 size={15} className="mt-0.5 flex-shrink-0 text-brand-sage" aria-hidden="true" />
            {feat}
          </li>
        ))}
      </ul>

      {available && (
        <Link
          to="/#contact"
          className="btn-primary text-sm justify-center w-full"
        >
          Schedule a Tour
        </Link>
      )}
    </div>
  )
}
